export default __webpack_public_path__ + "static/media/711.545e28e6.png";